import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@metarouter-private/mr-mui';

export default function ConfirmSendEventMessage({ integrationName, clusterName }) {
  return (
    <Typography variant="body1" color="text.secondary">
      Are you sure you want to send a live event to the{' '}
      <Typography fontWeight="700" component="span">
        {integrationName}
      </Typography>{' '}
      integration in the{' '}
      <Typography fontWeight="700" component="span">
        {clusterName}
      </Typography>{' '}
      cluster?
    </Typography>
  );
}

ConfirmSendEventMessage.propTypes = {
  integrationName: PropTypes.string.isRequired,
  clusterName: PropTypes.string.isRequired,
};
